import { Heading, Icon, Span, type UiIconNames } from "@icg360/design-system";

import { formatCurrency } from "utils";

import styles from "./core-coverages.module.scss";

export const CoreCoverages = ({ coveragesList, labelledCoverages }) => {
  const coverageValueDisplay = (coverageValue) => {
    return coverageValue && coverageValue !== "0"
      ? formatCurrency(coverageValue)
      : "N/A";
  };

  const coverageKeyMap: Record<
    string,
    { icon: UiIconNames; label: string; details: string }
  > = {
    dwelling: {
      icon: "House",
      label: "Dwelling (Coverage A)",
      details:
        "Coverage to help repair or rebuild your home if it's damaged or destroyed.",
    },
    otherStructures: {
      icon: "Fence",
      label: "Other structures (Coverage B)",
      details:
        "Coverage for things like sheds, garages, and fences that are not your home.",
    },
    personalProperty: {
      icon: "Computer",
      label: "Personal property (Coverage C)",
      details:
        "Coverage for your belongings that aren't attached to your home, like furniture and clothing.",
    },
    lossOfUse: {
      icon: "Keys",
      label: "Loss of use (Coverage D)",
      details:
        "Coverage for a temporary place to stay and living expenses such as food, if your home is damaged and you can't live there.",
    },
    personalLiability: {
      icon: "PremiumAnalysis",
      label: "Personal liability (Coverage E)",
      details:
        "Coverage for lawsuits if you or a family member is found responsible for injuring someone else or their property.",
    },
    medicalPayments: {
      icon: "PhysicalInjury",
      label: "Medical payments",
      details:
        "Covers medical expenses for someone if they are injured on your property.",
    },
  };

  return coveragesList?.map((coverage) => (
    <div className={styles.coverageItemHeader} key={coverage.name}>
      <div className={styles.coverageIcon}>
        <Icon name={coverageKeyMap[coverage.key].icon} size="lg" />
      </div>
      <div className={styles.contentWrapper}>
        <div className={styles.content}>
          <Heading size="xs">{coverageKeyMap[coverage.key].label}</Heading>
          <Span color="quiet">{coverageKeyMap[coverage.key].details}</Span>
        </div>
        <div className={styles.valueDS}>
          <Span bold>
            {coverageValueDisplay(
              labelledCoverages && labelledCoverages[coverage.key],
            )}
          </Span>
        </div>
      </div>
    </div>
  ));
};
